import { AccountBalance } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { formatMoney } from 'lib/functions/utils';
import React from 'react';

type PayoutPlanTitleProps = {
  actualAmountToDeposit: number;
  totalAmountToDeposit: number;
};
const PayoutPlanTitle = ({
  actualAmountToDeposit,
  totalAmountToDeposit,
}: PayoutPlanTitleProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ width: '100%' }}
    >
      <Box
        sx={{
          backgroundColor: 'primary.main',
          borderRadius: '50%',
          p: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
        }}
      >
        <AccountBalance sx={{ fontSize: '1rem' }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: '1rem',
            lineHeight: 1.1,
          }}
        >
          Plan de Giro
        </Typography>
      </Box>
      {totalAmountToDeposit > 0 ? (
        <Box sx={{ textAlign: 'right' }}>
          <Stack
            direction="row"
            alignItems="start"
            justifyContent="flex-end"
            spacing={0.75}
          >
            <Typography variant="h5" color="secundary">
              {formatMoney(actualAmountToDeposit)}
            </Typography>
            <Typography variant="h5" color="primary">
              /
            </Typography>
            <Typography variant="h5" color="primary" fontWeight={500}>
              {formatMoney(totalAmountToDeposit)}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              CLP
            </Typography>
          </Stack>
        </Box>
      ) : (
        <Box sx={{ textAlign: 'right' }}>
          <Stack
            direction="row"
            alignItems="start"
            justifyContent="flex-end"
            spacing={0.75}
          >
            <Typography variant="body2">
              El monto a girar no ha sido definido...
            </Typography>
          </Stack>
        </Box>
      )}
    </Stack>
  );
};

export default PayoutPlanTitle;
